import {SortConfig} from '@softline/application';

export const sortConfig: SortConfig = {
  properties: []
}
